<template>
  <div v-if="isCorreiosUser">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex sm12 md12>
          <v-card style="min-height: 100vh">
            <v-card-title style="margin: auto" class="container">
              <span class="headline"
                >{{
                  user && user.customer_id ? "Editar" : "Inscrever"
                }}
                Membro</span
              >
            </v-card-title>
            <v-card-text>
              <v-alert
                v-if="user && user.customer_id && user.signedcontract_at"
                :value="true"
                type="warning"
              >
                <p v-html="assinou" />
              </v-alert>
              <v-alert v-if="cpf_duplicated" :value="true" type="warning">
                <p v-html="cpf_duplicated_msg" />
              </v-alert>
              <v-alert v-if="cpf_duplicated" :value="true" type="warning">
                <p v-html="cpf_duplicated_msg" />
              </v-alert>
              <v-alert v-if="financial_pending" :value="true" type="error">
                <p v-html="financial_pending" />
              </v-alert>
              <v-container grid-list-md class="pa-0">
                <v-layout wrap>
                  <v-flex xs12 sm6 md3 v-if="!person_type_preset">
                    <v-select
                      :items="person_type_items"
                      item-value="value"
                      item-text="text"
                      label="Entidade*"
                      v-model="person_type"
                      :rules="[(v) => !!v || 'Por favor, informe o tipo']"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-select
                      id="utilityCompanyInput"
                      label="Concessionária*"
                      v-model="utility_company"
                      :items="utilityCompanies"
                      item-value="id"
                      item-text="name"
                      :rules="[
                        (v) => !!v || 'Por favor, informe a Concessionária',
                      ]"
                      required
                    />
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field
                      id="cpf"
                      v-model="cpf"
                      autofocus
                      :label="person_type === 'pf' ? 'CPF' : 'CNPJ'"
                      :mask="
                        person_type === 'pf'
                          ? '###.###.###-##'
                          : '##.###.###/####-##'
                      "
                      @click:append-outer="buscaDadosComplementares(cpf, false)"
                      append-outer-icon="autorenew"
                      :rules="
                        person_type === 'pf'
                          ? [
                              (v) =>
                                v.length >= 11 || 'Preencha o CPF Completo',
                              (v) =>
                                this.validaCPF(this.cpf) === true ||
                                'CPF inválido',
                            ]
                          : [
                              (v) =>
                                v.length >= 14 || 'Preencha o CNPJ Completo',
                              (v) =>
                                this.validaCNPJ(this.cpf) === true ||
                                'CNPJ inválido',
                            ]
                      "
                      @change="buscaDadosComplementares($event, true)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md3>
                    <v-text-field
                      label="E-mail"
                      v-model="email"
                      read-only
                      hint="E-mail principal do membro"
                      :rules="[
                        (v) => !!v || 'Por favor, informe o email',
                        (v) =>
                          /^(([^<>()\[\]\\.,;:\s@&quot;]+(\.[^<>()\[\]\\.,;:\s@&quot;]+)*)|(&quot;.+&quot;))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
                            v,
                          ) || 'E-mail precisa ser válido',
                      ]"
                      name="email"
                      :disabled="user.customer_id ? true : false"
                      type="email"
                      required
                      @click:append="buscaMember(email, 'email')"
                      append-icon="autorenew"
                      @change="buscaMember($event, 'email')"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm4 md4 lg6>
                    <v-text-field
                      label="Matrícula dos Correios"
                      v-model="correiosMatricula"
                      name="matricula"
                      type="number"
                      mask="########"
                      hint="Preencher em caso de migração de empregados"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm4 md4 lg6>
                    <v-text-field
                      label="Média de Consumo"
                      v-model.number="average"
                      name="average"
                      hint="Selecione primeiro a concessionária"
                      :rules="[
                        (v) => !!v || 'Por favor, informe a média de consumo',
                      ]"
                      required
                      type="number"
                      prefix="R$"
                      :readonly="!this.utility_company"
                    ></v-text-field>
                  </v-flex>
                  <v-layout row wrap v-if="ucs_list">
                    <v-flex xs12>
                      <p class="font-weight-bold">
                        Esse cliente já possui unidades consumidoras
                        cadastradas.
                      </p>
                    </v-flex>
                    <v-flex v-for="list in ucs_list" :key="list.id">
                      <v-card max-width="310">
                        <v-card-title>
                          <v-flex xs2>
                            <v-icon large left> home </v-icon>
                          </v-flex>
                          <v-flex xs5>
                            <span class="title font-weight-light">{{
                              list.id
                            }}</span>
                          </v-flex>
                          <v-flex>
                            <v-tooltip
                              bottom
                              v-if="
                                list.status === 'canceling' ||
                                list.status === 'canceled'
                              "
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  small
                                  dark
                                  round
                                  :color="list.status | formatUCStatusColor"
                                  v-on="on"
                                >
                                  <strong>{{
                                    list.status | formatUCStatus
                                  }}</strong>
                                </v-btn>
                              </template>
                              <span
                                v-if="
                                  list.status_reason ||
                                  list.status_reason_description
                                "
                                ><br />
                                <div v-if="list.canceled_at">
                                  <strong>Cancelado em: </strong
                                  >{{ list.canceled_at | formatarDate }}
                                  <br /><br />
                                </div>
                                <strong>Motivo: </strong
                                >{{ list.status_reason | formatStatusReason
                                }}<br /><br />
                                <strong>Descrição: </strong
                                >{{ list.status_reason_description }}
                              </span>
                              <span v-else>Motivo: {{ list.bot_status }}</span>
                            </v-tooltip>
                            <v-btn
                              small
                              dark
                              round
                              :color="list.status | formatUCStatusColor"
                              v-else
                            >
                              <strong>{{
                                list.status | formatUCStatus
                              }}</strong>
                            </v-btn>
                          </v-flex>
                        </v-card-title>
                        <v-card-text>
                          <p class="font-weight-bold subtitle">
                            {{ list.name }}
                          </p>
                          <p
                            class="caption"
                            v-if="list.address && list.address.address"
                          >
                            {{ list.address.address }},
                            {{ list.address.address_number }},
                            {{ list.address.district }},
                            {{ list.address.city }}/{{
                              list.address.state.initials
                            }}
                            - CEP: {{ list.address.postal_code }}
                          </p>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn
                        dark
                        @click.prevent="buscaDadosComplementares(cpf, false)"
                        >Adicionar Unidades Consumidoras</v-btn
                      >
                    </v-flex>
                    <v-flex xs12>
                      <v-alert
                        v-if="
                          ucs_list && ucs_list.length > 0 && status === 'ATIVO'
                        "
                        :value="true"
                        type="warning"
                      >
                        <p
                          v-html="
                            'Só é possivel adicionar novas unidades consumidoras. Para reativar unidades já cadastradas é necessário fazer pela tela de Clientes.'
                          "
                        />
                      </v-alert>
                    </v-flex>
                  </v-layout>
                  <v-container pa-0 v-if="average > 0">
                    <v-layout row wrap>
                      <v-flex
                        v-for="plan in plansEconomySort"
                        :key="plan.id"
                        xs6
                        sm4
                        md4
                        lg4
                      >
                        <v-card
                          @click.prevent="choosePlan(plan)"
                          class="ma-1 card_border"
                          hover
                          :style="
                            selected_plan && selected_plan.id === plan.id
                              ? 'border: 1px solid blue;'
                              : 'border: 1px solid #c0c0c0;'
                          "
                        >
                          <v-flex xs12 class="pa-0 ma-0">
                            <div
                              style="background: #efefef; position: absolute"
                              pa-2
                              ma-0
                            >
                              <v-icon
                                size="36px"
                                left
                                color="blue"
                                v-if="
                                  selected_plan && selected_plan.id === plan.id
                                "
                              >
                                check_circle
                              </v-icon>
                            </div>
                            <h4
                              v-if="plan.name.startsWith('Black')"
                              class="pa-2 mt-0 mb-0 text-xs-center font-weight-bold"
                              style="background: #efefef"
                            >
                              {{ plan.name }} - Fidelidade de 12 meses
                            </h4>
                            <h4
                              v-if="!plan.name.startsWith('Black')"
                              class="pa-2 mt-0 mb-0 text-xs-center font-weight-bold"
                              style="background: #efefef"
                            >
                              {{ plan.name }}
                            </h4>
                            <div
                              v-if="plan.name.startsWith('Black')"
                              class="body-3 pt-1 mt-0 mb-0 blue--text text-xs-center font-weight-bold"
                              style="
                                border-bottom-width: 2px;
                                border-bottom-style: solid;
                                border-bottom-color: #efefef;
                              "
                            >
                              {{ plan.discount }}% de desconto no primeiro ano*
                            </div>
                            <div
                              v-if="!plan.name.startsWith('Black')"
                              class="body-3 pt-1 mt-0 mb-0 blue--text text-xs-center font-weight-bold"
                              style="
                                border-bottom-width: 2px;
                                border-bottom-style: solid;
                                border-bottom-color: #efefef;
                              "
                            >
                              {{ plan.discount }}% de desconto
                            </div>
                            <h5 class="pt-0 pb-0 mb-1 mt-2 text-xs-center">
                              Economize até
                            </h5>
                            <div
                              class="pt-0 text-xs-center display-1 text-no-wrap"
                            >
                              <small class="body-1">R$ </small
                              >{{ plan.economy_year | formatCurrency
                              }}<small class="body-1"> ao ano</small>
                            </div>
                          </v-flex>
                          <v-layout xs6 class="text--center justify-center">
                            <div
                              class="body-2 px-4 py-1 black--text text-xs-center"
                              style="background: #efefef; border-radius: 10px"
                            >
                              R$
                              <span class="font-weight-bold text-xs-center">{{
                                plan.economy_mounth | formatCurrency
                              }}</span>
                              por mês
                            </div>
                          </v-layout>
                          <plan-conditions :plan="plan" />
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <v-layout
                    row
                    wrap
                    v-if="
                      !(ucs_list && ucs_list.length > 0 && status === 'ATIVO')
                    "
                  >
                    <v-flex xs12 sm9 md6 v-if="person_type === 'pj'">
                      <v-text-field
                        label="Razão Social"
                        v-model="company_name"
                        type="text"
                        required
                        :rules="[
                          (v) =>
                            !!v ||
                            'Por favor, informe a razão social da empresa',
                        ]"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md4 lg4>
                      <v-text-field
                        :label="
                          'Nome Completo' +
                          (person_type === 'pj'
                            ? ' do Representante Legal'
                            : '')
                        "
                        v-model="name"
                        type="text"
                        required
                        :hint="nome_titular"
                        :rules="[
                          (v) => !!v || 'Por favor, informe o seu nome',
                          (v) =>
                            v.length >= 10 ||
                            'Por favor, preencha o nome completo.',
                        ]"
                      ></v-text-field>
                      <input
                        type="hidden"
                        name="nome_titular"
                        v-model="nome_titular"
                      />
                    </v-flex>
                    <v-flex xs12 sm5 md3>
                      <v-text-field
                        type="tel"
                        v-model="phone"
                        :rules="[
                          (v) => !!v || 'Por favor, informe o celular',
                          (v) =>
                            v.length > 10 ||
                            'Ops. Parece que esse não é um número de telefone',
                        ]"
                        prepend-icon="phone"
                        @click:prepend="call(phone)"
                        return-masked-value
                        mask="(##)#####-####"
                        label="Telefone"
                        hint="Preferencialmente um telefone com whatsapp"
                        persistent-hint
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm1 md1 pt-4>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon @click="dialog_phones = true" v-on="on"
                            >add</v-icon
                          >
                        </template>
                        <span>Mais telefones</span>
                      </v-tooltip>
                      <span
                        v-if="
                          phones &&
                          phones.length > 0 &&
                          phones.filter((p) => p.phone !== '').length != 0
                        "
                        class="caption"
                      >
                        {{
                          phones && phones.length > 0
                            ? phones.filter((p) => p.phone !== "").length
                            : 0
                        }}
                      </span>
                    </v-flex>

                    <v-flex xs12 sm6 md4 v-if="person_type === 'pj'">
                      <v-text-field
                        id="cpf_legal_responsible"
                        v-if="person_type === 'pj'"
                        v-model="cpf_legal_responsible"
                        autofocus
                        label="CPF do Representante Legal"
                        :mask="'###.###.###-##'"
                        :rules="[
                          (v) =>
                            !!v ||
                            'Por favor, informe o CPF do representante legal da empresa!',
                          (v) => v.length >= 11 || 'Preencha o CPF Completo',
                          (v) =>
                            this.validaCPF(this.cpf_legal_responsible) ===
                              true || 'CPF inválido',
                        ]"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2 v-if="person_type === 'pf'">
                      <v-text-field
                        id="rg"
                        v-model="rg"
                        label="Documento"
                        hint="RG ou outro oficial"
                        :rules="[
                          (v) =>
                            v.length > 7 ||
                            'Ops. Parece que esse não é um número valido',
                        ]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md2 v-if="person_type === 'pf'">
                      <v-text-field
                        id="orgao_expeditor"
                        v-model="orgao_expeditor"
                        label="Orgão Expeditor"
                        hint="ex. SSP/MG"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md3 v-if="person_type === 'pf'">
                      <v-text-field
                        label="Data de Nasc"
                        v-model="birthday"
                        mask="##/##/####"
                        :rules="[
                          (v) =>
                            v.length > 9 ||
                            'Ops. Parece que esse não é um data valida',
                        ]"
                        return-masked-value
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 md1 v-if="person_type === 'pf'">
                      <v-select
                        :items="['M', 'F']"
                        label="Sexo"
                        v-model="gender"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3 v-if="status">
                      <v-text-field
                        v-model="status"
                        label="Status do Membro"
                        hint="readonly"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 md3 v-if="psellers">
                      <v-autocomplete
                        :items="psellers"
                        item-text="name"
                        item-value="email"
                        label="Vendido por"
                        v-model="signedcontract_partner"
                        hint="opcional"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs4 sm4 md3>
                      <v-text-field
                        v-model="cupom"
                        label="Cupom de desconto (Opcional)"
                        prepend-icon="mdi-sale"
                        name="cupom"
                        required
                        filled
                        rounded
                        dense
                        ref="cupom"
                        @keyup="uppercaseCoupon"
                        @keypress="clearCupom"
                        @keydown="clearCupom"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 sm2 md2>
                      <v-btn
                        color="indigo"
                        small
                        @click="validateCupom(cupom)"
                        :loading="loadingCupom"
                        :disabled="loadingCupom"
                      >
                        Aplicar
                      </v-btn>
                    </v-flex>
                    <v-flex xs6 sm6 md3>
                      <div
                        v-if="!isValidCoupon && couponMessage"
                        class="red--text font-weight-bold pt4"
                      >
                        {{ couponMessage }}
                      </div>
                      <div
                        v-else-if="isValidCoupon && couponMessage"
                        class="green--text font-weight-bold"
                      >
                        {{ couponMessage }}
                      </div>
                    </v-flex>
                    <v-flex
                      xs12
                      sm12
                      md12
                      v-if="qualifications && qualifications.length > 0"
                      class="pa-0"
                    >
                      <QualificationList />
                      <v-list three-line>
                        <template
                          v-for="(qualification, idx) in qualifications"
                        >
                          <qualifying-card
                            :key="idx"
                            :qualification="qualification"
                            :installations_found="ucs_cemig"
                            v-if="qualification.status === 'pending'"
                          />
                          <not-qualified-card
                            :key="idx"
                            :qualification="qualification"
                            :installations_found="ucs_cemig"
                            v-if="
                              qualification.status === 'bill_not_found' ||
                              qualification.status === 'error'
                            "
                          />
                          <disqualified-card
                            :key="idx"
                            :qualification="qualification"
                            :installations_found="ucs_cemig"
                            v-if="qualification.status === 'disqualified'"
                          />
                          <qualified-card
                            :key="idx"
                            :qualification="qualification"
                            :installations_found="ucs_cemig"
                            v-if="qualification.status === 'qualified'"
                          />
                        </template>
                      </v-list>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions
              style="margin: auto; padding-bottom: 20px"
              class="container"
            >
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="clearUser"
                >Limpar</v-btn
              >
              <v-btn
                color="blue darken-1"
                v-if="!lead.user || (lead.user && !lead.user.status)"
                :loading="loading"
                :disabled="
                  loading || is_disqualification || isQualifing || !canSell
                "
                @click.prevent="validate"
                type="submit"
                >Inscrever</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar
        :color="color"
        :bottom="bottom"
        :top="top"
        :left="left"
        :right="right"
        multi-line
        v-model="snackbar"
        dark
      >
        <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
        <div v-html="snackMessage"></div>
        <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
      </v-snackbar>
    </v-form>
    <v-dialog v-model="dialog_ucs" persistent max-width="500px">
      <v-card class="pa-3">
        <v-card-title class="pa-0 pt-2">
          <span class="title font-weight-bold mx-auto"
            >Unidades Consumidoras do Cliente na Cemig</span
          >
        </v-card-title>
        <v-card-text class="pt-1 pb-3 px-0">
          <v-list subheader three-line>
            <v-subheader
              >Selecione as unidades consumidoras que o membro quer
              contratar.</v-subheader
            >
            <v-list-tile
              v-for="(uc, idx) in ucs_cemig"
              :key="uc.installation_number"
            >
              <v-list-tile-action>
                <v-checkbox
                  v-model="ucs_checkbox"
                  :value="idx"
                  :color="colors[idx]"
                ></v-checkbox>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{
                  uc.installation_number
                }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ uc.address }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <div class="mx-auto">
            <v-btn
              color="primary"
              text
              @click="dialog_ucs = false"
              :disabled="loading_qualification"
              >Fechar</v-btn
            >
            <v-btn
              color="pink darken-1"
              text
              :loading="loading_qualification"
              :disabled="ucs_checkbox?.length == 0 || !ucs_checkbox"
              @click="ucs_selected()"
              >Selecionar</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_cpf" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ label_loading_cpf }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_venda" persistent max-width="500px">
      <v-card>
        <v-card-title> Ao aceitar o termo você concorda em: </v-card-title>
        <v-card-text>
          <v-list subheader three-line>
            <v-list-tile>
              <v-list-tile-content>
                1. Receber um percentual dos créditos gerados de acordo com seu
                consumo médio.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                2. Que é o titular da conta de luz ou possui declaração legal
                para representá-lo.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                3. Está ciente de que é necessário o aviso prévio de 90 dias
                para cancelamento da assinatura.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                4. Receberá 10% de desconto sobre os créditos recebidos em
                relação a tarifa vigente pela concessionária local.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                5. Esta ciente que somente receberá cobrança após os créditos
                chegarem em sua conta de energia.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                6. Realizará o pagamento pelos créditos recebidos dentro do
                prazo. Caso isso não ocorrá poderá ter seu nome adicionado aos
                sistemas de crédito.
              </v-list-tile-content>
            </v-list-tile>
            <v-divider />
            <v-list-tile>
              <v-list-tile-content>
                7. Permite que o representante legal da cooperativa faça a
                inscrição em seu nome junto a CEMIG.
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog_venda = false"
            >fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_app" persistent max-width="500px">
      <v-card>
        <v-container fluid grid-list-lg>
          <v-card-title> Baixe nosso App </v-card-title>
          <v-card-text>
            <v-list subheader two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-sub-title>
                    <v-text-field
                      width="100%"
                      readonly
                      id="applestore"
                      v-model="applestore"
                      label="Apple Store"
                      value="https://apps.apple.com/br/app/enercred/id1465641135"
                    ></v-text-field>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn
                    icon
                    color="blue"
                    @click.prevent="copyURL('applestore')"
                  >
                    <v-icon>content_copy</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider />
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-sub-title>
                    <v-text-field
                      readonly
                      id="googleplay"
                      v-model="googleplay"
                      label="Google Play"
                      value="https://play.google.com/store/apps/details?id=com.enecred.enercredapp&hl=pt_BR"
                    ></v-text-field>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn
                    icon
                    color="blue"
                    @click.prevent="copyURL('googleplay')"
                  >
                    <v-icon>content_copy</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="dialog_app = false"
              >fechar</v-btn
            >
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_calculator" persistent max-width="450px">
      <v-card color="#FFF">
        <Calculator :average="lead.average_consumption || 0" />
        <v-layout pa-2>
          <v-spacer />
          <v-btn dark color="blue" @click="dialog_calculator = false"
            >Fechar</v-btn
          >
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_phones" persistent max-width="650px">
      <v-card color="#FFF">
        <v-form ref="phones_form">
          <v-container py-0>
            <v-layout wrap>
              <v-flex xs12 md12 pa-3>
                <span class="headline">Telefones</span>
              </v-flex>
              <v-flex xs12 md12>
                <v-list two-line subheader>
                  <v-subheader>Telefone primário</v-subheader>
                  <v-list-tile>
                    <a :href="'tel:+55' + phone.replace(/\D/g, '')">
                      <v-text-field
                        type="tel"
                        v-model="phone"
                        :rules="[
                          (v) => !!v || 'Por favor, informe o celular',
                          (v) =>
                            v.length > 10 ||
                            'Ops. Parece que esse não é um número de telefone',
                        ]"
                        prepend-icon="phone"
                        return-masked-value
                        mask="(##)#####-####"
                        label="Telefone"
                        disabled
                      ></v-text-field>
                    </a>
                  </v-list-tile>
                  <v-subheader>Telefones secundários</v-subheader>
                  <v-list-tile v-for="(item, index) in phones" :key="index">
                    <v-layout row>
                      <v-flex xs12 lg5>
                        <v-text-field
                          v-model="item['name']"
                          prepend-icon="badge"
                          label="Descrição"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 lg6>
                        <v-text-field
                          type="tel"
                          v-model="item['phone']"
                          prepend-icon="phone"
                          :rules="[
                            (v) =>
                              v.length > 10 ||
                              'Ops. Parece que esse não é um número de telefone',
                          ]"
                          return-masked-value
                          mask="(##)#####-####"
                          label="Telefone"
                          :append-icon="
                            item['phone'].length > 10 ? 'check' : undefined
                          "
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-list-tile>
                  <v-list-tile>
                    <v-spacer />
                    <v-btn
                      small
                      dark
                      color="tertiary"
                      @click="phones.push({ name: '', phone: '' })"
                      >Adicionar mais</v-btn
                    >
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-layout pa-2>
          <v-spacer />
          <v-btn dark color="blue" @click="dialog_phones = false">Fechar</v-btn>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog v-model="saleDialog" max-width="290" dark>
      <v-card color="#7C3DFF">
        <v-card-title class="headline">Venda Concluída!</v-card-title>
        <v-card-text
          >Informe ao cliente que ele deverá enviar a conta de luz conforme
          passo a passo descrito no comprovante de atendimento. Após, já pode
          fechar a janela da venda.</v-card-text
        >
      </v-card>
    </v-dialog>

    <v-dialog v-model="disableToSellDialogOpen" max-width="300px">
      <v-card>
        <v-card-title>
          <h3>Lembrete</h3>
          <v-spacer></v-spacer>
          <v-btn flat icon @click="disableToSellDialogOpen = false">
            <v-icon color="red">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid class="pa-0">
            <v-layout row wrap>
              <v-flex xs12>
                <div v-html="disabledSellMessage"></div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import statesfile from "@/model/state";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { eventBus } from "../../main";
import { setFbEvent } from "../../services/facebookOfflineEvents";
import { getCEP } from "../../services/getCep";
import { getCPFCemig } from "../../services/getCPFCemig";
import { getPEOPLE } from "../../services/getPeople";
import { addLead, updateLead } from "../../services/leads";
import { initQualification } from "../../services/qualification";
import { saveAnalytics } from "../../services/save_analytics";
import {
  getMember,
  getPartnerSellers,
  storeCustomer,
  updateUser,
} from "../../services/users";
import lista_profissoes from "../../utils/profissoes.json";
import firestore from "@/firebase/firestore";
import moment from "moment";
import QualificationList from "../../components/correios/QualificationList.vue";
import PlanConditions from "../../components/plans/PlanConditions.vue";
import Calculator from "../../components/sales/Calculator";
import DisqualifiedCard from "../../components/sales/qualification/DisqualifiedCard";
import NotQualifiedCard from "../../components/sales/qualification/NotQualifiedCard.vue";
import QualifiedCard from "../../components/sales/qualification/QualifiedCard.vue";
import QualifyingCard from "../../components/sales/qualification/QualifyingCard.vue";
import { SET_CONVERSION } from "../../graphql/rdstation";
import { getConsumerUnits } from "../../services/consumer_units";
import api from "../../utils/api";
import { formatPhone, reversePhone } from "../../utils/utils";

export default {
  data: function () {
    return {
      dialog_member: false,
      cpf_duplicated: false,
      cpf_duplicated_msg: "",
      dialog_ucs: false,
      dialog_cpf: false,
      dialog_venda: false,
      dialog_app: false,
      dialog_calculator: false,
      dialog_phones: false,
      financial_pending: null,
      label_loading_cpf: "Validando CPF informado",
      ucs_chbox: [],
      valid: false,
      profissoes: lista_profissoes,
      lead: {},
      cadLead: "new",
      name: "",
      nome_titular: "",
      phone: "",
      phones: [{ name: "", phone: "" }],
      email: "",
      average: 0,
      person_type_items: [
        { text: "Pessoa Física", value: "pf" },
        { text: "Pessoa Jurídica", value: "pj" },
      ],
      contract_time_items: [
        { text: "1 Ano", value: 12 },
        { text: "3 Anos", value: 36 },
        { text: "5 Anos", value: 60 },
      ],
      enercred_contract: true,
      person_type: "pf",
      company_name: "",
      cpf: "",
      old_cpf: "",
      cpf_legal_responsible: "",
      rg: "",
      birthday: "",
      mother_name: "",
      orgao_expeditor: "",
      user: {},
      marital_status: [
        { text: "Solteiro(a)", value: "Solteiro(a)" },
        { text: "Casado(a)", value: "Casado(a)" },
        { text: "Separado(a)", value: "Separado(a)" },
        { text: "Divorciado(a)", value: "Divorciado(a)" },
        { text: "Viúvo(a)", value: "Viúvo(a)" },
      ],
      marital_status_value: "",
      marital_type: [
        { text: "Comunhão Universal de Bens", value: "Universal de bens" },
        { text: "Comunhão Parcial de Bens", value: "Parcial de bens" },
        { text: "Separação Total de Bens", value: "Separação total" },
        {
          text: "Participação Final nos Aquestos",
          value: "Final nos aquestos",
        },
      ],
      marital_type_value: "",
      gender: "",
      cemig_status: true,
      cep: "",
      logradouro: "",
      numero: "",
      complemento: "",
      bairro: "",
      localidade: "",
      uf: "",
      state: {
        initials: "",
        name: "",
      },
      profissao: "",
      consumer_unit: "",
      states: statesfile.estados,
      payment_type: "boleto",
      status: "",
      signedcontract_at: "",
      signedcontract_partner: "Correios",
      signedcontract_by: "Correios",
      loading: false,
      loading_cpf: false,
      loading_cep: false,
      loading_qualification: false,
      color: null,
      utm_source: "",
      utm_medium: "",
      utm_campaign: "",
      utm_term: "",
      utm_content: "",
      platform: "super",
      colors: ["purple", "info", "success", "warning", "error"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackMessage: "",
      snackbar: false,
      currentUser: {},
      activator: null,
      attach: null,
      colors_uc: ["green", "purple", "indigo", "cyan", "teal", "orange"],
      editing: null,
      index: -1,
      items: [
        { header: "Selecione um opção ou adicione um núm. de instalação" },
      ],
      nonce: 1,
      menu: false,
      ucs: [],
      applestore: "https://apps.apple.com/br/app/enercred/id1465641135",
      googleplay:
        "https://play.google.com/store/apps/details?id=com.enecred.enercredapp&hl=pt_BR",
      processo_vendas: {
        cordialidade: true,
        produto: false,
        titularidade: false,
        venda: false,
        condicoes: false,
        duasfaturas: false,
      },
      contract_time: 12,
      contract_time_enable: false,
      ucs_list: null,
      ucs_cemig: [],
      uc: {},
      is_disqualification: false,
      x: 0,
      search: null,
      y: 0,
      cupom: null,
      isValidCoupon: true,
      couponMessage: null,
      loadingCupom: false,
      psellers: null,
      plans_economy: [],
      selected_plan: null,
      docfrente: null,
      docverso: null,
      docself: null,
      dialog_fotos: false,
      e6: 1,
      fileInfo: null,
      save_btn_label: "Salvar",
      tabulation: null,
      isCorreiosUser: false,
      correiosMatricula: "",
      saleDialog: false,
      canSell: false,
      successDialog: false,
      user_exists: true,
      ucs_checkbox: [],
      utility_company: null,
      company: "juntos",
      person_type_preset: false,
      disableToSellDialogOpen: false,
    };
  },
  components: {
    Calculator,
    QualifiedCard,
    DisqualifiedCard,
    QualifyingCard,
    NotQualifiedCard,
    PlanConditions,
    QualificationList,
  },

  async created() {
    this.clearUser();
    this.isCorreiosUser = true;
    await this.correiosLogin();
    const qry_person_type = this.$route.query.person_type;
    if (qry_person_type && qry_person_type !== "") {
      this.person_type = qry_person_type;
      this.person_type_preset = true;
    }
  },

  computed: {
    ...mapState("configuration", ["utilityCompanies"]),
    ...mapState("sales", ["coupon", "plans", "tabulations"]),
    ...mapState("qualification", ["qualifications"]),
    ...mapGetters("qualification", [
      "qualifications",
      "isQualifing",
      "getQualificationsIds",
    ]),

    assinou() {
      if (this.user && this.user.signedcontract_at) {
        let msg = "";

        if (!this.user.contract_id && this.user.status !== "ATIVO") {
          msg =
            "Atenção: Cliente fez cadastro no passado e cancelou ou não foi ativado, revender para esse cliente?";
        } else {
          msg =
            'Atenção: Cliente <span class="font-weight-bold">' +
            this.user.status;
        }
        return msg;
      } else {
        return "";
      }
    },

    possuiContrato() {
      return !!(this.user && this.user.signedcontract_at);
    },

    plansEconomySort() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.plans_economy.sort((a, b) => (a.order > b.order ? 1 : -1));
    },

    isQualified() {
      const qualifications = this.qualifications.filter(
        (qualification) => qualification.status === "qualified",
      );
      return qualifications.length > 0;
    },

    qualification_ids() {
      return this.getQualificationsIds ?? [];
    },

    disabledSellMessage() {
      if (!this.utility_company) return null;
      const uc = this.utilityCompanies.find(
        (item) => item.id === this.utility_company,
      );
      return uc.enabled_to_sell_msg;
    },
  },

  async mounted() {
    if (this.utilityCompanies?.length <= 0)
      await this.getUtilityCompanies({ origin: "correios" });
    if (
      (!this.plans || (this.plans && this.plans.length <= 0)) &&
      this.person_type &&
      this.person_type != "" &&
      this.utility_company
    ) {
      await this.getPlansByParams({
        person_type: this.person_type,
        utility_company: this.utility_company,
        company: this.company,
      });
    }
    eventBus.$on("Lead", (lead) => {
      let _lead = lead;
      this.lead = {};
      this.user = {};
      this.loading = true;
      if (lead) {
        if (lead.id && lead.saved_partner !== this.currentUser.email) {
          let newLead = {
            updated_at: new Date(),
            tabulation: "working",
            saved_at: new Date(),
            saved_by: "SUPER",
            saved_source: this.currentUser.partner_id || "enercred",
            saved_partner: this.currentUser.email,
          };
          updateLead(lead.email, newLead)
            .then(() => {})
            .catch((err) => {
              this.snack(
                "Houve um erro inesperado. Procure nosso suporte!",
                "red",
                "top",
              );
              console.error("Erro ao pegar lead: ", err);
              this.loading = false;
            });
          _lead = {
            ...lead,
            ...newLead,
          };
        }
        this.setLead(_lead);
      } else {
        this.clearUser();
      }
      this.getPSeller();
      this.dialog_member = true;
      this.loading = false;
    });
  },

  watch: {
    ucs(val, prev) {
      if (val.length === prev.length) return;

      this.ucs = val.map((v) => {
        if (typeof v === "string") {
          v = {
            text: v,
            color: this.colors[this.nonce - 1],
          };

          this.items.push(v);

          this.nonce++;
        }
        return v;
      });
    },

    qualifications() {
      let disqualification = this.qualifications.reduce((sum, cur) => {
        if (cur.status === "disqualified") return sum + 1;
        else return sum;
      }, 0);
      if (
        disqualification === this.qualifications.length &&
        disqualification > 0
      ) {
        this.is_disqualification = true;
      } else {
        this.is_disqualification = false;
      }
    },

    average() {
      this.getPlansEconomy(this.average, this.plans);
    },

    plans() {
      this.selected_plan = null;
      this.getPlansEconomy(this.average, this.plans);
    },

    async person_type() {
      this.selected_plan = null;
      if (this.person_type && this.person_type != "" && this.utility_company) {
        await this.getPlansByParams({
          person_type: this.person_type,
          utility_company: this.utility_company,
          company: this.company,
        });
      }
    },

    async utility_company() {
      this.selected_plan = null;

      await this.getPlansByParams({
        person_type: this.person_type,
        utility_company: this.utility_company,
        company: this.company,
      });

      const utilityCompanyData = this.utilityCompanies.find(
        (item) => item.id === this.utility_company,
      );

      if (utilityCompanyData?.enabled_to_sell_correios) {
        this.canSell = true;
      } else {
        this.canSell = false;
        this.disableToSellDialogOpen = true;
      }

      this.state = this.states.find(
        (item) => item.initials === utilityCompanyData?.state,
      ) || { initials: "", name: "" };
    },
  },

  deactivated() {
    this.resetState();
  },

  destroyed() {
    this.resetState();
    this.clearUser();
  },

  methods: {
    ...mapActions("configuration", ["getUtilityCompanies"]),
    ...mapActions("members", ["getUserByID", "anonymousLogin"]),
    ...mapActions("qualification", ["resetState", "getQualifications"]),
    ...mapActions("sales", [
      "getCoupons",
      "getPlansByParams",
      "getTabulations",
    ]),
    ...mapMutations("sales", ["setCoupon"]),
    ...mapMutations("qualification", ["setQualifications"]),

    undo() {
      this.$refs.signaturePad.clearSignature();
    },

    async correiosLogin() {
      try {
        const id = this.$route.params.id;
        if (!id) return false;
        await this.anonymousLogin();
        const user = await this.getUserByID(id);
        this.currentUser = user;
        return user.group.find((group) => group === "correios");
      } catch {
        return false;
      }
    },

    onFileInfo(value) {
      this.fileInfo = value;
      this.ui.snackbar.fileInfo = true;
    },

    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty);
      console.log(data);
    },

    close() {
      this.dialog_member = false;
      this.resetState();
    },

    choosePlan(plan) {
      this.selected_plan = plan;
    },

    call(phone) {
      const newPhone = formatPhone(phone, "+55").split("+55")[1];
      window.open("tel:" + newPhone, "_self");
    },

    setLead(lead) {
      this.lead = lead;
      this.cadLead = "edit";
      this.platform = lead.platform || "super";

      if (lead.plan && lead.plan.id) {
        this.selected_plan = this.plans.filter((value) => {
          return value.id === lead.plan.id;
        })[0];
      }
      if (lead.user) {
        if (this.cpf !== "" && lead.user.cpf !== this.cpf) {
          this.snack(
            "E-mail digitado possui cadastro com o CPF Diferente",
            "warning",
            "top",
          );
          return;
        }
        this.person_type = lead.user.person_type || "pf";
        if (
          (!this.plans || this.plans.length <= 0) &&
          this.person_type &&
          this.person_type != "" &&
          this.utility_company
        ) {
          this.getPlansByParams({
            person_type: this.person_type,
            utility_company: this.utility_company,
            company: this.company,
          });
        }
        let phone = reversePhone(lead.user.phone);
        let phones;
        if (lead && lead.user && lead.user.other_phones) {
          phones = lead.user.other_phones.map((e) => {
            return {
              name: e.name,
              phone: reversePhone(e.phone, "55"),
            };
          });
        }
        this.user = lead.user;
        this.name = lead.user.name;
        this.company_name = lead.user.company_name || "";
        this.email = lead.user.email;
        this.phone = phone;
        this.phones = phones;
        this.average = lead.user.average_consumption;
        this.cep = lead.user.postal_code;
        this.cpf = lead.user.cpf;
        this.cpf_legal_responsible = lead.user.cpf_legal_responsible;
        this.old_cpf = this.cpf;
        if (lead.user.ID_document) {
          let rg = lead.user.ID_document.split("-")[0];
          let org = lead.user.ID_document.split("-")[1];
          this.rg = rg;
          this.orgao_expeditor = org;
        }
        this.birthday = this.reverseDate(lead.user.date_of_birth);
        this.gender = lead.user.gender;
        this.consumer_unit = lead.user.installation_number || "";
        this.mother_name = lead.user.mother_name || "";
        if (lead.user.address) {
          this.cep =
            lead.user.address.postal_code ||
            lead.address.postal_code ||
            lead.postal_code ||
            null;
          this.logradouro = lead.user.address.address;
          this.numero = lead.user.address.address_number;
          this.complemento = lead.user.address.address_complement;
          this.bairro = lead.user.address.district;
          this.localidade = lead.user.address.city;
          this.state = lead.user.address.state;
        }
        if (!this.installation_numbers)
          this.installation_numbers = lead.user.installation_numbers || [];
        this.ucs = this.installation_numbers;
        this.items = lead.user.installation_numbers || [];
        this.payment_type = lead.user.payment_type;
        this.unique_billing = lead.user.unique_billing;
        this.status = lead.user.status;
        this.signedcontract_at = this.formatDate(lead.user.signedcontract_at);
        this.signedcontract_by =
          lead.user.signedcontract_by === "onboarding" ||
          lead.user.signedcontract_by === "mobile_app"
            ? ""
            : lead.user.signedcontract_by;
        this.enercred_contract = lead.user.enercred_contract;
        if (lead.user.coupon) this.coupon = lead.user.coupon;
      } else {
        this.user = {};
        this.clearUser();
        if (lead.name) {
          this.person_type = lead.person_type || "pf";
          if (
            (!this.plans || this.plans.length <= 0) &&
            this.person_type &&
            this.person_type != "" &&
            this.utility_company
          ) {
            this.getPlansByParams({
              person_type: this.person_type,
              utility_company: this.utility_company,
              company: this.company,
            });
          }
          let phone = reversePhone(lead.phone);
          let phones = [];
          if (lead && lead.other_phones) {
            phones = lead.other_phones.map((e) => {
              return {
                name: e.name,
                phone: reversePhone(e.phone, "55"),
              };
            });
          }
          this.name = lead.name;
          this.person_type = lead.person_type || "pf";
          this.company_name = lead.company_name || "";
          this.email = lead.email;
          this.phone = phone;
          this.phones = phones;
          this.average = lead.average_consumption;
          this.cep = lead.postal_code;
          this.cpf = lead.cpf || "";
          this.cpf_legal_responsible = lead.cpf_legal_responsible;
          this.old_cpf = this.cpf || "";
          if (lead.ID_document) {
            let rg = lead.ID_document.split("-")[0];
            let org = lead.ID_document.split("-")[1];
            this.rg = rg;
            this.orgao_expeditor = org;
          }
          this.birthday = this.reverseDate(lead.date_of_birth) || "";
          this.gender = lead.gender || "";
          this.consumer_unit = lead.installation_number || "";
          this.mother_name = lead.mother_name || "";
          if (lead.address) {
            this.cep = lead.address.postal_code || lead.postal_code || null;
            this.logradouro = lead.address.address;
            this.numero = lead.address.address_number;
            this.complemento = lead.address.address_complement;
            this.bairro = lead.address.district;
            this.localidade = lead.address.city;
            this.state = lead.address.state;
          }
          if (!this.installation_numbers)
            this.installation_numbers = lead.installation_numbers || [];
          this.ucs = lead.installation_numbers || [];
          this.items = lead.installation_numbers || [];
          this.payment_type = lead.payment_type || "boleto";
          this.unique_billing = lead.unique_billing;
          this.signedcontract_by =
            lead.signedcontract_by === "onboarding" ||
            lead.signedcontract_by === "mobile_app"
              ? ""
              : lead.signedcontract_by;
          this.enercred_contract = lead.enercred_contract || true;
          if (lead.coupon) this.coupon = lead.coupon;
        }
      }
    },
    copyURL(element) {
      let Url = document.getElementById(element);
      Url.innerHTML = Url.value;
      Url.select();
      document.execCommand("copy");
      alert("Copiado com sucesso.");
    },
    edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.index = index;
      } else {
        this.editing = null;
        this.index = -1;
      }
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    buscaCep(cep) {
      if (cep && cep !== "") {
        this.loading_cep = true;
        getCEP(cep, "correios")
          .then((result) => {
            this.logradouro = result.data.logradouro;
            this.numero = result.data.numero;
            this.complemento = result.data.complemento;
            this.bairro = result.data.bairro;
            this.localidade = result.data.localidade;
            this.uf = result.data.UF;
            this.loading_cep = false;
          })
          .catch((error) => {
            console.error(error);
            getCEP(cep)
              .then((result) => {
                this.logradouro = result.data.logradouro;
                this.numero = result.data.numero;
                this.complemento = result.data.complemento;
                this.bairro = result.data.bairro;
                this.localidade = result.data.localidade;
                this.uf = result.data.UF;
                this.loading_cep = false;
              })
              .catch((error) => {
                this.snack(
                  "Erro ao buscar o CEP informado. Erro: " + error,
                  "red",
                  "top",
                );
                this.loading_cep = false;
              });
          });
      }
    },

    show_dialog_ucs() {
      this.dialog_ucs = true;
    },

    async buscaMember(param, type) {
      this.dialog_cpf = true;
      this.user_exists = false;
      this.label_loading_cpf =
        "Verificando se " + type + " já está cadastrado...";
      await getMember(param, type)
        .then(async (lead) => {
          this.lead.user;
          if (lead && lead.id && lead.user && lead.user.id) {
            let _hasSubscription = await this.hasSubscription(
              lead.user ? lead.user : lead.id,
            );
            if (_hasSubscription && _hasSubscription.items) {
              //Não vamos deixar inscrever
              this.user_exists = true;
              this.ucs_list = _hasSubscription.items;
              this.snack(
                "Usuário já existe e possui Unidades Consumidoras cadastradas",
                "red",
                "top",
              );
            } else if (!_hasSubscription) {
              //Vamos deixar inscrever
              this.canSell = true;
            }
            this.setLead(lead);
          } else if (lead && lead.id) {
            this.setLead(lead);
          }
        })
        .catch((error) => {
          console.error("error: ", error);
        });
      if (type == "email") {
        this.dialog_cpf = false;
      }
    },

    async buscaDadosComplementares(cpf, validaDuplicate) {
      if (validaDuplicate) {
        if (this.cadLead !== "edit") {
          this.valid = true;
        }
      } else {
        if (
          cpf && cpf !== "" && this.person_type === "pf"
            ? this.validaCPF(cpf)
            : this.validaCNPJ(cpf)
        ) {
          this.dialog_cpf = true;
          this.label_loading_cpf = "Verificando se CPF já está cadastrado...";
          await this.buscaMember(cpf, "cpf");
          if (!this.user_exists) {
            this.label_loading_cpf =
              "Buscando dados do membro na Concessionária...";
            await getCPFCemig(cpf)
              .then((ret) => {
                if (ret.status === 200) {
                  this.ucs_cemig = ret.data;
                  ret.data.forEach((data, idx) => {
                    const item_uc = {
                      text: data.installation_number,
                      color: this.colors[idx],
                    };
                    this.installation_numbers.push(item_uc);
                  });
                  if (this?.qualifications[0]?.cpf != this.cpf) {
                    this.setQualifications([]);
                  }
                  this.name = this.ucs_cemig[0].name;
                  this.loadingDialog = false;
                  this.dialog_ucs = true;
                } else {
                  this.snack(
                    "Atenção: CPF não encontrado no site da CEMIG, validar se o CPF informado é do titular da conta.",
                    "warning",
                    "top",
                  );
                  this.valid = false;
                }
              })
              .catch((err) => {
                console.error(err);
                this.snack("Prossiga com o cadastro.", "green", "top");
              });
          }
          this.label_loading_cpf = "Buscando dados complementares do membro...";
          if (this.person_type === "pf")
            getPEOPLE(cpf)
              .then((result) => {
                if (result.data.BasicData) {
                  this.nome_titular = result.data.BasicData.Name || "";
                  this.name = result.data.BasicData.Name || "";
                  this.gender = result.data.BasicData.Gender || "";
                  this.nacionalidade =
                    result.data.BasicData.BirthCountry || "brasileiro(a)";
                  this.mother_name = result.data.BasicData.MotherName || "";
                  this.birthday = this.formatDate(
                    result.data.BasicData.BirthDate,
                  );
                }
                if (
                  result.data.ProfessionData &&
                  result.data.ProfessionData.TotalProfessions > 0
                ) {
                  if (
                    result.data.ProfessionData.Professions &&
                    result.data.ProfessionData.Professions.length > 0
                  ) {
                    result.data.ProfessionData.Professions.forEach((t) => {
                      if (t.Level !== "UNKNOWN") {
                        this.profissao = t.Level;
                      }
                    });
                  }
                }
                this.dialog_cpf = false;
              })
              .catch((error) => {
                console.error(
                  "CPF não encontrado na base de dados externa. Por favor, preencha os dados (Data nascimento, sexo, etc...) manualmente. Erro: " +
                    error,
                );
                this.dialog_cpf = false;
              });
          this.dialog_cpf = false;
        }
      }
    },

    async ucs_selected() {
      this.loading_qualification = true;
      const ucs = this.ucs_checkbox.map((index) => this.ucs_cemig[index]);
      const installationNumbers = ucs?.map((uc) => uc.installation_number);
      for (const uc of ucs) {
        const ucFound = (
          await firestore
            .collection("consumer_units")
            .doc(uc.installation_number)
            .get()
        )?.data();

        const statusAllowedToSell = [
          "activated",
          "awaiting_signature",
          "awaiting_contract_generation",
          "canceling",
          "interrupting",
          "interrupted",
        ];

        const uc_status = {
          activated: "Ativo",
          awaiting_signature: "Aguardando assinatura de contrato",
          awaiting_contract_generation: "Aguardando geração de contrato",
          canceling: "Em cancelamento",
          interrupting: "Interrompendo fornecimento",
          interrupted: "Fornecimento interrompido",
        };

        if (statusAllowedToSell.includes(ucFound?.status)) {
          const text = `A UC ${uc.installation_number} já existe com status ${
            uc_status[ucFound.status]
          }.`;
          this.errorOnInitQualification(text, "error");
          return;
        }

        const qualificationFound = this.qualifications.some(
          (item) => item.consumer_unit == uc.installation_number,
        );
        if (qualificationFound) {
          const text = `A UC ${uc.installation_number} já foi adicionada a lista de qualificação.`;
          this.errorOnInitQualification(text, "warning");
          return;
        }
      }
      await initQualification(
        this.cpf,
        null,
        installationNumbers,
        "correios",
        false,
        null,
        this.utility_company,
        ucs,
        "correios",
      )
        .then((ret) => {
          if (ret.status === 200) {
            const qualification_ids = ret.data.ids;
            const params = {
              cpf: this.cpf,
              qualification_ids: qualification_ids,
            };
            this.getQualifications(params);
          }
        })
        .catch((err) => {
          console.error(err);
          this.snack(
            `Erro ao iniciar qualificação. ${
              err?.response ? err.response.data : ""
            }`,
            "warning",
            "bottom",
          );
          this.$emit("showUcsList", this.plans);
        });
      this.loading_qualification = false;
      this.ucs_checkbox.map((sel, index) => {
        const obj = {
          text: sel,
          color: this.colors[index],
        };
        this.ucs.push(obj);
      });
      this.ucs_checkbox = [];
      this.dialog_ucs = false;
    },
    errorOnInitQualification(text, type) {
      this.loading_qualification = false;
      this.dialog_ucs = false;
      this.ucs_checkbox = [];
      this.snack(text, type, "top");
    },

    clearUser() {
      this.cadLead = "new";
      this.valid = false;
      this.user = {};
      this.lead = {};
      this.name = "";
      this.person_type = "pf";
      this.company_name = "";
      this.nome_titular = "";
      this.email = "";
      this.phone = "";
      this.phones = [{ name: "", phone: "" }];
      this.average = "";
      this.cep = "";
      this.cpf = "";
      this.cpf_legal_responsible = "";
      this.rg = "";
      this.birthday = "";
      this.gender = "";
      this.profissao = "";
      this.marital_type_value = "";
      this.marital_status_value = "";
      this.consumer_unit = "";
      this.installation_number = "";
      this.installation_numbers = [];
      this.mother_name = "";
      this.orgao_expeditor = "";
      this.cep = "";
      this.logradouro = "";
      this.numero = "";
      this.complemento = "";
      this.bairro = "";
      this.localidade = "";
      this.items = [];
      this.ucs = [];
      this.ucs_chbox = [];
      this.state = {
        initials: "",
        name: "",
      };
      this.payment_type = "boleto";
      this.signedcontract_by = "Correios";
      this.signedcontract_source = "";
      this.signedcontract_at = "";
      this.signedcontract_partner = "Correios";
      this.utm_source = null;
      this.utm_medium = null;
      this.utm_campaign = null;
      this.utm_term = null;
      this.utm_content = null;
      this.platform = "super";
      this.enercred_contract = true;
      this.ucs_list = null;
      this.financial_pending = null;
      this.selected_plan = null;
      this.utility_company = null;
    },

    getPlansEconomy(average, plans) {
      if (!this.utility_company) {
        return;
      }
      this.plans_economy = [];
      for (const plan of plans) {
        let mounth =
          (average * (1 - 0.09) - 50) * (plan.discount / 100 || 0.15);
        let year = mounth * 12;
        this.plans_economy.push({
          economy_mounth: mounth,
          economy_year: year,
          ...plan,
        });
      }
    },

    snack(message, color, ...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },

    formatDate(value) {
      if (!value || value === "") return "";
      if (new Date(value)) {
        return moment.utc(new Date(value)).format("DD/MM/YYYY");
      } else {
        return value;
      }
    },

    validaCPF(strCPF) {
      if (!strCPF) return "";
      let Soma;
      let Resto;
      Soma = 0;
      if (strCPF == "00000000000") return false;
      if (strCPF == "11111111111") return false;

      for (let i = 1; i <= 9; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10))) return false;

      Soma = 0;
      for (let i = 1; i <= 10; i++)
        Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if (Resto == 10 || Resto == 11) Resto = 0;
      return Resto == parseInt(strCPF.substring(10, 11));
    },

    validaCNPJ(strCNPJ) {
      if (!strCNPJ) return "";
      let cnpj = strCNPJ.replace(/[^\d]+/g, "");

      if (cnpj.length != 14) return false;

      if (
        cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999"
      )
        return false;

      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(0)) return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      return resultado == digitos.charAt(1);
    },

    async validaCPFNaBase(cpf) {
      if (
        this.person_type === "pf" ? this.validaCPF(cpf) : this.validaCNPJ(cpf)
      ) {
        const ret = await firestore
          .collection("users")
          .where("cpf", "==", cpf)
          .limit(1)
          .get();
        if (ret.size > 0) {
          let msg =
            `${
              this.person_type === "pf" ? "CPF" : "CNPJ"
            } já cadastrado na base com o email ` +
            ret.docs[0].data().email +
            ".";
          if (ret.docs[0].data().signedcontract_at) {
            let dt_assin = moment(
              new Date(ret.docs[0].data().signedcontract_at),
            ).format("DD/MM/YYYY HH:mm");
            msg =
              msg +
              "<br>Cliente assinou o contrato em <b>" +
              dt_assin +
              "</b> por meio ";
            if (
              ret.docs[0].data().signedcontract_by === "SUPER" ||
              ret.docs[0].data().signedcontract_by === "phone" ||
              ret.docs[0].data().signedcontract_by === "chat" ||
              ret.docs[0].data().signedcontract_by === "telefone" ||
              ret.docs[0].data().signedcontract_by === "Pessoalmente"
            ) {
              msg =
                msg +
                "de <b>Callcenter</b> - Vendido por: <b>" +
                ret.docs[0].data().signedcontract_partner +
                "</b>";
            } else {
              msg = msg + "<b>Online</b>";
            }
            if (ret.docs[0].data().status) {
              msg =
                msg +
                "<br> Cliente com status: <b>" +
                ret.docs[0].data().status +
                "</b>";
            }
          }
          if (ret.docs[0].data().email !== this.email) {
            this.valid = false;
            this.snack(msg, "red", "top");
            this.cpf_duplicated = true;
            this.cpf_duplicated_msg = msg;
            return true;
          } else {
            this.cpf_duplicated = false;
            this.cpf_duplicated_msg = "";
            return false;
          }
        } else {
          this.cpf_duplicated = false;
          this.cpf_duplicated_msg = "";
          return false;
        }
      } else {
        this.cpf_duplicated = false;
        this.cpf_duplicated_msg = "";
        return false;
      }
    },
    /**
     * Registra atendimento nos correios e atualiza campo correios do usuário informacoes de sucesso ou erro
     * quando sucesso preenche no campo correios: { isServiceOk: true, ... }
     * quando erro preenche no campo correios: { isServiceOk: false, ... }
     */
    async registerCorreiosService(userData) {
      const correiosServiceData = {
        codigoCorreios: this.$route.query.codigoCorreios,
        numeroIdentificacaoCliente: userData.cpf,
        quantidade: "1",
        chaveCliente: userData.email || userData.cpf,
        textoTicket: `Boas-vindas a Juntos Energia!
Segue o passo a passo para migrar sua conta
para a Juntos e receber energia limpa e barata:
1. Envie para nosso WhatsApp (35) 9 9756-0252 uma
   conta de luz recente (ultimos dois meses).
2. Nosso time de atendimento realizara a qualifica-
   ção e retornara em até 12 horas.
3. Voce recebera o contrato no e-mail cadastrado.
4. De o aceite no contrato para concluir a adesao.`,
      };
      let correiosInfo = null;

      try {
        const response = await api.post(
          process.env.VUE_APP_REGISTER_CORREIOS_SERVICE,
          correiosServiceData,
        );
        correiosInfo = {
          correios: {
            isServiceOk: true, //isServiceOk: flag para verificar se atendimento deu erro ou nao
            responseStatus: response.status,
            responseData: response.data,
            matricula: this.correiosMatricula,
          },
          signedcontract_partner: "Correios",
          signedcontract_by: "Correios",
          signedcontract_at: new Date().toISOString(),
        };

        return correiosInfo;
      } catch (error) {
        if (error.response) {
          correiosInfo = {
            "correios.isServiceOk": false,
            "correios.responseStatus": error.response.status,
            "correios.responseData": error.response.data,
          };
        } else {
          correiosInfo = {
            "correios.isServiceOk": false,
            "correios.error": error.name,
            "correios.message": error.message,
          };
        }

        throw {
          code: "correios/service-not-registered",
          reponseData: error.response ? error.response.data : error,
        };
      }
    },

    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        if (this.cadLead === "new" || this.old_cpf !== this.cpf) {
          if (await this.validaCPFNaBase(this.cpf)) {
            console.error("cpf já existe na base");
            this.loading = false;
            return;
          }
        }
        if (this.cupom && this.cupom.trim() !== "") {
          let valida = await this.validateCupom(this.cupom.trim());
          if (!valida) {
            this.loading = false;
            return;
          }
        }

        let status = "AGUARDANDO_CONTA";
        let termo_uso = "Sim";

        let phone = formatPhone(this.phone, "+55");
        let other_phones = [];
        if (this.phones) {
          other_phones = this.phones.map((e) => {
            return {
              name: e.name,
              phone: formatPhone(e.phone, "+55"),
            };
          });
        }
        if (!this.person_type || this.person_type.trim() === "") {
          this.snack(
            "Por favor informe se é um cadastro de PF ou PJ!",
            "warning",
            "top",
          );
          this.loading = false;
          return;
        }
        if (!this.selected_plan) {
          this.snack(
            "Por favor informe o Plano selecionado pelo Cliente!",
            "warning",
            "top",
          );
          this.loading = false;
          return;
        }

        let newUser = {
          name: this.name,
          person_type: this.person_type,
          company_name: this.company_name,
          email: this.email.toLowerCase().trim() || this.email,
          phone: phone,
          other_phones:
            other_phones && other_phones.length > 0
              ? other_phones.filter((e) => e.phone != "")
              : [],
          group: "customer",
          address: {
            address: this.logradouro || "",
            address_number: this.numero || "",
            address_complement: this.complemento || "",
            district: this.bairro || "",
            postal_code: this.cep || "",
            state: this.state || {
              initials: "",
              name: "",
            },
            city: this.localidade || "",
            country: {
              initials: "br",
              name: "Brasil",
            },
          },
          ID_document: this.rg + "-" + this.orgao_expeditor,
          average_consumption: this.average,
          cpf: this.cpf,
          password: this.cpf,
          date_of_birth: this.birthday,
          gender: this.gender,
          installation_number: this.consumer_unit || "",
          installation_numbers: this.ucs,
          nationality: this.nacionalidade || "brasileiro(a)",
          payment_type: this.payment_type,
          mother_name: this.mother_name || "",
          requiredPSChange: 1,
          created_at: new Date(),
          updated_at: new Date(),
          platform: this.platform || "super",
          tabulation: this.tabulation,
          utility_company: this.utility_company,
        };

        if (
          newUser?.utility_company === "cemig" &&
          this.payment_type === "boleto"
        ) {
          newUser.unique_billing = true;
        } else {
          newUser.unique_billing = false;
        }

        if (this.person_type === "pj") {
          newUser.cpf_legal_responsible = this.cpf_legal_responsible;
          newUser.enercred_contract = this.enercred_contract;
        }
        let plan = {
          id: this.selected_plan.id,
          name: this.selected_plan.name,
          contract_time: this.selected_plan.contract_time,
          discount: this.selected_plan.discount,
        };
        plan.contract_time = this.selected_plan.contract_time;
        newUser.plan = plan;

        if (!this.user.customer_id) {
          newUser.status = status;
          newUser.termouso = termo_uso;
          newUser.signedcontract_at = new Date().toISOString();
          newUser.signedcontract_by = this.signedcontract_by || "Correios";
          newUser.signedcontract_source =
            this.currentUser.partner_id || "enercred";
          if (this.signedcontract_partner) {
            newUser.signedcontract_partner = this.signedcontract_partner;
            newUser.created_by = this.currentUser.email;
          } else newUser.signedcontract_partner = this.currentUser.email;
        }
        if (this.coupon && this.cupom) {
          newUser.coupon = this.coupon;
          if (this.coupon.type === "referral") {
            newUser.promo_code = this.coupon.user;
          }
        }
        if (!this.user.customer_id) {
          const history = {
            created_at: new Date(),
            user_id: this.currentUser.email,
            action: "created",
          };
          newUser.history = [];
          newUser.history.push(history);
        } else {
          newUser.history = this.user.history || [];
          const history = {
            created_at: new Date(),
            user_id: this.currentUser.email,
            action: "updated",
          };
          newUser.history.push(history);
        }

        newUser.qualification_ids = this.qualification_ids;

        storeCustomer(newUser)
          .then(async (user) => {
            if (user.status === 200 && user.data.id) {
              //Registra venda nos Correios
              let correiosInfo = null;
              try {
                console.log("Registrando venda nos Correios...");
                correiosInfo = await this.registerCorreiosService(newUser);
                if (
                  correiosInfo &&
                  correiosInfo?.correios?.responseData?.protocolo
                ) {
                  //Atualiza usuário no banco
                  await updateUser(user.data.id, correiosInfo);
                }

                if (!correiosInfo?.correios?.responseData?.protocolo) {
                  throw {
                    code: "correios/protocolo-not-found",
                    reponseData: {
                      mensagem:
                        "Cadastro sem protocolo Correios. Venda novamente!",
                    },
                  };
                }
              } catch (error) {
                if (error.code === "correios/service-not-registered") {
                  let err = "";
                  let err_msg =
                    "Erro ao registrar atendimento nos correios, tente novamente.";
                  let msg_correios = error.responseData
                    ? error.responseData.mensagem
                    : "Erro Correios";
                  if (msg_correios && typeof msg_correios === "string") {
                    msg_correios = msg_correios.split("chaveCorreios:")[0];
                    err = msg_correios;
                  }
                  correiosInfo = null;
                  return this.snack(err_msg + " - " + err, "red", "top");
                }

                if (error.code === "correios/protocolo-not-found") {
                  const err_msg = error.responseData.mensagem;
                  correiosInfo = null;
                  return this.snack(err_msg, "red", "top");
                }

                correiosInfo = null;
                this.loading = false;
                this.snack(JSON.stringify(error));
              }

              //Para a execução da função caso atendimento nos correios não tenha sido registrado
              if (!correiosInfo) return;

              if (!this.user.customer_id) {
                if (this.cadLead === "edit") {
                  const data = {
                    signedcontract_at: new Date(),
                    signedcontract_by: "Correios",
                    termouso: "Sim",
                    signedcontract_source: "Correios",
                    signedcontract_partner: "Correios",
                  };
                  updateLead(this.email, data)
                    .then(() => {
                      return;
                    })
                    .catch((err) => {
                      console.error("Erro ao criar lead: ", err);
                    });
                } else {
                  addLead(newUser)
                    .then(() => {
                      return;
                    })
                    .catch((err) => {
                      console.error("Erro ao criar lead: ", err);
                    });
                }

                if (this.ucs.length > 0) {
                  this.ucs.map((uc) => {
                    const analytics = {
                      eventCategory: "NOVO",
                      eventAction: "SUBSCRIPTION",
                      eventLabel: this.currentUser.partner_id || "enercred",
                      transaction_id: user.data.email,
                      value: user.data.average_consumption,
                      utm_source: this.utm_source || "SUPER",
                      utm_medium: this.utm_medium || this.signedcontract_by,
                      utm_campaign: this.utm_campaign || "",
                      utm_content: this.utm_content || "",
                      utm_term: this.utm_term || "",
                      boleto: true,
                      uc: uc.text,
                    };
                    saveAnalytics(analytics);
                  });
                } else {
                  const analytics = {
                    eventCategory: "NOVO",
                    eventAction: "SUBSCRIPTION",
                    eventLabel: this.currentUser.partner_id || "enercred",
                    transaction_id: user.data.email,
                    value: user.data.average_consumption,
                    utm_source: "SUPER",
                    utm_medium: this.signedcontract_by,
                    utm_campaign: this.currentUser.email,
                    boleto: true,
                    uc: "não informado",
                  };
                  saveAnalytics(analytics);
                }
              } else {
                if (newUser.signedcontract_at) {
                  if (this.ucs.length > 0) {
                    this.ucs.map((uc) => {
                      const analytics = {
                        eventCategory: "NOVO",
                        eventAction: "SUBSCRIPTION",
                        eventLabel: this.currentUser.partner_id || "enercred",
                        transaction_id: user.data.email,
                        value: user.data.average_consumption,
                        utm_source: "SUPER",
                        utm_medium: this.signedcontract_by,
                        utm_campaign: this.currentUser.email,
                        boleto: true,
                        uc: uc.text,
                      };
                      saveAnalytics(analytics);
                    });
                  } else {
                    const analytics = {
                      eventCategory: "NOVO",
                      eventAction: "SUBSCRIPTION",
                      eventLabel: this.currentUser.partner_id || "enercred",
                      transaction_id: user.data.email,
                      value: user.data.average_consumption,
                      utm_source: "SUPER",
                      utm_medium: this.signedcontract_by,
                      utm_campaign: this.currentUser.email,
                      boleto: true,
                      uc: "não informado",
                    };
                    saveAnalytics(analytics);
                  }
                }
              }
              this.user = user.data;
              this.lead.user = user.data;
              eventBus.$emit("Lead", this.lead);

              let conversion = {
                event_type: "SALE",
                event_family: "CDP",
                payload: {
                  email: user.data.email,
                  funnel_name: "default",
                  value: 200,
                },
              };

              if (conversion.event_type) {
                this.$apollo.mutate({
                  // Query
                  mutation: SET_CONVERSION,
                  // Parameters
                  variables: {
                    event_type: conversion.event_type,
                    event_family: conversion.event_family,
                    payload: conversion.payload,
                  },
                });
              }

              //Cadastra evento Offline no facebook
              const valor = newUser.name.split(" ");
              let nome = valor.shift();
              let sobrenome = valor.join(" ");
              let fb_data = {
                email: newUser.email,
                fn: nome || newUser.name,
                ln: sobrenome || newUser.name,
                phone: phone,
                gen: newUser.gender,
                extern_id: user.data.id,
                lead_id: newUser.email,
                value: newUser.average_consumption || 250,
                currency: "BRL",
                customer_id: user.data.id,
              };
              if (newUser.address && newUser.address.city)
                fb_data.ct = newUser.address.city;
              if (newUser.address && newUser.address.postal_code)
                fb_data.zip = newUser.address.postal_code;

              setFbEvent(fb_data, "inside_sale", "Purchase");

              this.snack("Venda realizada com sucesso!", "green", "top");
            }
            this.loading = false;
            this.saleDialog = true;
          })
          .catch((error) => {
            console.error("Erro ao realizar venda!", JSON.stringify(error));
            let err_msg = "Erro ao gravar membro! Contate nosso suporte.";
            if (error.code === "auth/email-already-in-use") {
              err_msg = "Este email está sendo utilizado por outra conta.";
              this.snack(err_msg + " - " + error, "red", "top");
              return;
            } else if (error.code === "correios/service-not-registered") {
              err_msg = "Erro ao registrar atendimento nos correios";
              let msg_correios = error.responseData
                ? error.responseData.mensagem
                : "Erro Correios";
              if (msg_correios && typeof msg_correios === "string") {
                msg_correios = msg_correios.split("chaveCorreios:")[0];
                error = msg_correios;
              }
              this.snack(err_msg + " - " + error, "red", "top");
              return;
            }
            this.snack(err_msg + " - " + error, "red", "top");
            this.loading = false;
          });
      } else this.snack("Preencha todos os campos obrigatórios.", "red", "top");
    },

    async hasSubscription(user) {
      if (!user.customer_id) return true;
      let args = {
        searchBy: {
          field: "user_id",
          operator: "==",
          value: user.customer_id,
        },
      };
      let ucs = await getConsumerUnits(args).get();
      if (ucs.size > 0) {
        let _ucs = [];
        for (let i = 0; i < ucs.size; i++) {
          _ucs.push({ id: ucs.docs[i].id, ...ucs.docs[i].data() });
        }
        return {
          items: _ucs,
        };
      }
      return null;
    },

    correctDateOffset(date, offset) {
      date.setHours(date.getHours() + offset);
      return date;
    },

    getPSeller() {
      getPartnerSellers()
        .then((psellers) => {
          this.psellers = psellers.docs.map((u) => {
            return {
              id: u.id,
              ...u.data(),
            };
          });
        })
        .catch((err) => console.error(err));
    },

    reverseDate(date) {
      if (!date || date === "") return "";
      if (typeof date !== "string") {
        return moment.utc(new Date(date)).format("DD/MM/YYYY");
      } else {
        let ano = date.split("/")[2];
        let _ano = date.split("-")[0];

        if (_ano && _ano.length <= 4) {
          let dia = "";
          if (date.split("-")[2]) {
            dia = date.split("-")[2].substring(0, 2);
          }
          let mes = date.split("-")[1];
          return dia + mes + _ano;
        } else if (ano && ano.length <= 4) {
          let dia = "";
          if (date.split("/")[0]) {
            dia = date.split("/")[0].substring(0, 2);
          }
          let mes = date.split("/")[1];
          return dia + mes + ano;
        }
        return date;
      }
    },

    validateCupom(cupom) {
      this.loadingCupom = true;
      if (!cupom || cupom.trim() === "") {
        this.loadingCupom = false;
        this.isValidCoupon = true;
        return true;
      }
      return this.getCoupons(cupom)
        .then(async (res) => {
          this.isValidCoupon = res.status;
          this.couponMessage =
            res.message === "Ok" ? "Cupom aplicado com sucesso!" : res.message;
          this.loadingCupom = false;
          return res.status;
        })
        .catch((err) => {
          console.error(err);
          this.isValidCoupon = false;
          this.couponMessage = err.message;
          this.loadingCupom = false;
          this.valid = false;
          return false;
        });
    },

    clearCupom() {
      this.isValidCoupon = true;
      this.couponMessage = null;
    },

    uppercaseCoupon() {
      this.cupom = this.cupom ? this.cupom.toUpperCase() : "";
    },
  },
};
</script>

<style>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.container {
  width: "100%";
  padding: 8px 16px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
</style>
